import { SlabsComponent } from './../slabs/slabs.component';
import { Subscription } from 'rxjs';
import { Component, Input, OnInit, EventEmitter, OnChanges, SimpleChanges, Output, OnDestroy, ViewChild, ElementRef, inject } from '@angular/core';
import { AbstractControl, FormControl, FormGroup, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { ICLientData, ICurrency, IUser } from '../../../../shared/models';
import {
  PaymentService, UtilService, VariablesService, StorageService, EventsService, AuthService, ScriptLoaderService, VwoService, ApiService, PaymentV2Service
} from '../../../../shared/services';
import { ICart } from '../../models/cart.model';
import { IContribute, IRewards } from '../../models/contribute.model';
import { AMOUNT_FORM } from '../../objects/amount.form';
import { PaymentUtilService } from '../../services';
import { IPaymentParam } from '../../../../shared/models/payment-params.model';
import { IPageConfig } from '../../objects/page.config';
import { MatDialog } from '@angular/material/dialog';
import { ISipCause } from '../../../../fundraiser/models/fundraiser.model';
import { IPaymentConfig } from '../../models/payment.model';
import { Currency } from 'src/app/shared/models/currency-list';

@Component({
  selector: 'app-amount-form',
  templateUrl: './amount-form.component.html',
  styleUrls: ['./amount-form.component.scss']
})
export class AmountFormComponent implements OnInit, OnChanges, OnDestroy {

  readonly vars = inject(VariablesService);

  @Input() campaignId;
  @Input() contributeDetails: IContribute;
  @Input() isReward;
  @Input() config: IPageConfig;
  @Input() isLoading;
  @Input() paymentFlowType;
  @Output() userSelectionCurrency: EventEmitter<ICurrency> = new EventEmitter();
  @Output() isSumbited: EventEmitter<boolean> = new EventEmitter();
  @Input() isRewardSelected;
  @Input() isQR;
  @Input() fixedAmount;
  @Input() eventCause;
  @Input() event;
  @Input() upiMode;
  @Input() onpage;
  @Input() captchaType;
  @Input() skipFailedCase;
  @Input() paymentIcons;
  @Input() recommendTag;
  @Input() inputFields;
  @Input() position;
  @Input() origin;
  @Input() isSipStory;
  @Input() payment_config: IPaymentConfig;
  @Input() tagLabel;
  @Input() theme;
  @Input() miniStory;
  @Output() submitOrder = new EventEmitter();
  /**Forms input */
  amountForm: FormGroup;
  amount;
  familyInsuranceAmount = 0;
  nameControl = new FormControl('', [Validators.required, Validators.pattern(this.vars.name_Pattern_Regex), Validators.minLength(3)]);
  mobileControl = new FormControl('', Validators.required);
  emailControl = new FormControl('', [Validators.required, Validators.pattern(this.vars.email_Pattern_Regex)]);
  nationality: FormControl;
  captcha: FormControl;
  address;
  pincode;
  pancard;
  passport;
  is_anonymous: FormControl;
  info = AMOUNT_FORM;
  isMobile: any;

  inputFieldData = {
    email: '',
    phone: ''
  };

  supportedCurrencies: ICurrency[] = [];
  clientData: ICLientData;
  cartResponse: ICart;
  slabs: any[] = [];
  reward: IRewards;
  currency;
  currencyDetails: ICurrency;
  params: IPaymentParam;
  isLoggedIn;
  geocoder;
  backPressed = false;
  isPanCardExists = false;
  askPassport = false;
  askPincode;
  extn;
  failedTransaction;
  cartValues;
  tipAmount;
  tipPercent;
  baseAmount;
  selectedNationality: any = true;
  initialContributeLoad = false;
  subs: Subscription[] = [];
  @ViewChild('paytmLoginRef', { static: true }) public paytmLogin;
  @ViewChild('captchaRef') captchaRef;
  @ViewChild(SlabsComponent) slabsComponent!: SlabsComponent;
  dialogRef;
  exitCounter = 0;
  enableCaptha = false;
  screen;
  sipAmount = 0;
  isSipCause = false;
  memorialTooltip = false;
  sipCause: ISipCause;
  ngo_sip;
  user: IUser;
  isEdit;
  fromToggleTip = false;
  randomDonorCount = 0;
  max_donation = 50000000;
  bulkdata;
  bulkamount;
  bulkShown = false;
  pancard_regex = /^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}?$/;
  is_any_active_sip;
  month_interval;
  addedExtraAmountCount = 0;

  showBulkDonationFor = /^(facebook|fbad|crt|adroll|taboola|tabool|keywee|keeyee|timescol|rtbhouse|Affiliates)/i;
  currencies = Currency;
  activeSips = [];
  optionCalled = false;
  selectedCountryData;

  @ViewChild('amountFormRef') private amountFormRef: ElementRef;

  constructor(
    private paymentService: PaymentService,
    public paymentUtilService: PaymentUtilService,
    public util: UtilService,
    public router: Router,
    private actiRoute: ActivatedRoute,
    private storageService: StorageService,
    public eventsService: EventsService,
    public authService: AuthService,
    public scriptLoaderService: ScriptLoaderService,
    public vwo: VwoService,
    public dialog: MatDialog,
    private apiService: ApiService,
    public paymentV2: PaymentV2Service
  ) {
    this.initForm();
    this.params = this.actiRoute.snapshot.queryParams;
  }

  ngOnInit() {
    if (this.vars.isAutoLogin) {
      this.updateValidation('email', true);
    }
    this.isMobile = this.util.isMobile();
    if (this.params?.st === 'f' && this.isMobile && this.vars.pageName.match('mini_story')) {
      this.util.scrollInto('amount-form-wrapper');
    }
    this.setConfig();
    this.actiRoute.queryParams.subscribe((params) => {
      // if (params.payment === 'form' && this.currency !== 'INR' && this.screen !== params.payment && this.vars.pageName !== 'stories') {
      //   this.toggleCaptcha(true);
      // }
      this.screen = params.payment;
      this.params = params;
    });
    if (this.fixedAmount) {
      this.amount = this.fixedAmount;
    }
    if (this.contributeDetails?.ngo_sip_campaign) {
      this.isSipCause = true;
      this.ngo_sip = true;
    }
    if (this.vars.showKCart) {
      this.subs.push(this.vars.kKartSelectionChange.subscribe(
        data => {
          this.setAmount(data?.amount || 0);
        }
      ));
    }
    this.failedTransaction = this.actiRoute.snapshot.queryParams['st'] === 'f';
    this.util.number.subscribe({
      next: (res) => {
        if (res && res.extn) {
          this.extn = res.extn;
        }
      }
    });
    this.subs.push(this.vars.clientLocationData.subscribe((res) => this.clientData = res));
    this.subs.push(this.paymentUtilService.paymentCurrency.subscribe({
      next: (res) => {
        this.currency = res;
        this.currencyDetails = this.util.getCurrencyIcon(this.currency);
        if (res && res !== 'INR') {
          this.info.pincode.placeholder = 'Zipcode';
          // if (this.vars.pageName !== 'stories') {
          //   this.toggleCaptcha(true);
          // }
        } else {
          this.toggleCaptcha(false);
        }
      }
    }));
    this.util.isLoggedIn.subscribe({
      next: (res) => {
        this.isLoggedIn = res;
        this.fillCart();
      }
    });
    setTimeout(() => { this.fillCart(); }, 0);
    this.rewardSelection();
    this.paytmLoginConsent();
    this.subs.push(this.vars.sip_cause.subscribe(
      (res) => {
        this.sipCause = null;
        if (res) {
          this.isSipCause = true;
          this.sipCause = res;
        }
      }
    ));
    this.subs.push(this.vars.onUpiOptionClick.subscribe(res => {
      if (!this.isLoading) {
        this.submitForm();
      }
    }));
    if (this.isQR?.name === 'UPI') {
      this.max_donation = 100000;
    }
    this.is_any_active_sip = this.util.checkForActiveSip(this.util.getUserData()?.listsubscriptions);
    this.activeSips = this.util.getActiveSip(this.util.getUserData()?.listsubscriptions);
    if (this.campaignId) {
      this.vars.campaignId = this.campaignId;
    }
    if (this.params?.sip_story) {
      this.paymentUtilService.paymentMode = 'recuring';
      this.month_interval = 1;
    }
    if (this.vars.isDummyEmail) {
      this.nameControl.setValue('');
      this.emailControl.setValue('');
    }
    if (this.vars.fundraiser?.settings?.verify_mobile) {
      this.subs.push(this.vars.leadGenData$.subscribe(res => {
        if (!res) { return; }
        this.amountForm.patchValue({
          mobile: this.user?.phone_1 || res.phone,
        });
      }));
    }
    this.subs.push(this.vars.tipCartCreated$.subscribe(cart => {
      if (cart) {
        this.cartResponse = cart;
        this.paymentUtilService.cartResponse.next(cart);
        this.paymentV2.paymentConfig.next({ cart: cart });
        this.util.storage.checkFromSession('cartData', cart);
        if (!cart?.eventPushed) {
          this.pushEvents();
        }
        this.vars.isOrderLoading = true;
        this.getPaymentOptions(cart.currency, true);
      }
    }));
    if (this.vars.pageName === 'stories' && this.vars.fundraiser?.cause?.id === 150) {
      this.paymentUtilService.paymentConfig.next({ enable_min_cart_lead: true });
    }
  }

  setConfig() {
    this.subs.push(this.paymentUtilService.paymentConfig.subscribe((c) => {
      if (c) {
        this.payment_config = { ...this.payment_config, ...c };
      }
    }));
  }

  toggleCaptcha(status) {
    this.enableCaptha = this.controlToggle('captcha', status);
    if (this.captchaRef && this.enableCaptha) {
      this.captchaRef.resetCaptcha();
      this.captchaRef.executeCaptcha();
      this.captcha.setValue('');
    }
  }

  /**Paytm login concent */
  paytmLoginConsent() {
    if (this.vars.isPaytmMini && !this.util.getUserData() && this.exitCounter < 3) {
      this.isLoading = true;
      this.paymentService.paytmAuthFetch().then((res: any) => {
        this.isLoading = false;
        if (res.data) {
          this.nameControl.setValue(res.data.profileInfo.displayName || '');
          this.emailControl.setValue(res.data.email || '');
          this.mobileControl.setValue(res.data.phoneInfo.phoneNumber || '');
        }
      }).catch(() => {
        this.isLoading = false;
        this.exitCounter++;
        if (this.exitCounter >= 3) {
          this.exitPaytm();
        } else {
          this.dialogRef = this.dialog.open(this.paytmLogin);
        }
      });
    }
  }
  /**Exit paytm screen */
  exitPaytm() {
    this.dialog.closeAll();
    ((<any>window).JSBridge).call('popWindow');
  }
  /**There are three ways of prefilling the cart
   * 1. If data present in the URL
   * 2. If the order failed then get cart from session storage
   * 3. If none of above the show the logged in user data
   */
  fillCart() {
    /**if the url comes with the prefilled data of failled cart */
    if (this.actiRoute.snapshot.queryParams['selected_currency']) {
      const cartDataFromLink: ICart = this.actiRoute.snapshot.queryParams;
      this.patchAmountForm(cartDataFromLink);
      /**If transaction failed then the cart details will pull from the session storage */
    } else if (this.storageService.getFromSession('cartData') && !this.vars.thirdPartyApp) {
      const cartData = this.storageService.getFromSession('cartData');
      this.user = this.util.getUserData();
      if (this.amount && this.params.st !== 'f') {
        cartData.donated_amount = this.amount;
      }
      cartData.pincode = this.user?.pincode;
      if (this.params.st === 'f') {
        if (this.optionCalled && cartData?.currency === this.paymentUtilService.paymentCurrency.value && cartData?.donated_amount === this.paymentUtilService.cartResponse.value?.donated_amount) return;
        this.optionCalled = true;
        this.patchAmountForm(cartData);
        this.paymentUtilService.paymentCurrency.next(cartData.currency);
        this.paymentUtilService.cartResponse.next(cartData);
        this.paymentV2.paymentConfig.next({ cart: cartData });
        this.subs.push(this.paymentUtilService.backButton.subscribe((res) => {
          if (res) {
            this.backPressed = true;
          }
        }));
        if (!this.backPressed && !this.isQR && !this.skipFailedCase) {
          this.getPaymentOptions(cartData.currency);
        }
      } else {
        this.patchAmountForm(cartData);
      }
      /**If user is logged in */
    } else if (this.util.getUserData()) {
      this.user = this.util.getUserData();
      this.fillStoryForm(this.user);
    }
  }

  fillStoryForm(userData) {
    if (userData) {
      this.nameControl.setValue(this.vars.isDummyEmail ? '' : userData.full_name);
      this.emailControl.setValue(this.vars.isDummyEmail ? '' : userData.email);
      this.mobileControl.setValue(userData.phone_1 === '1111111111' ? null : userData.phone_1);
    }
    if (userData?.address_1) {
      this.amountForm.patchValue({
        address: userData?.address_1 || ''
      });
    }
    if (userData?.pan_number?.info_1) {
      this.controlToggle('pancard', true, this.pancard_regex, userData?.pan_number?.info_1);
    }
    if (userData?.pincode) {
      this.amountForm.patchValue({
        pincode: userData?.pincode
      });
    }
  }

  rewardSelection() {
    this.subs.push(this.paymentUtilService.selectedReward.subscribe(reward => {
      if (reward) {
        this.reward = reward;
        this.isRewardSelected = true;
        this.isReward = true;
        this.amount = reward.amount;
      }
    }));
  }

  patchAmountForm(cartData: any) {
    this.cartValues = cartData;
    this.amount = cartData?.donated_amount_local || cartData?.donated_amount || this.amount;
    this.amountForm.patchValue({
      amount: cartData.donated_amount,
      name: cartData.donor_name,
      is_anonymous: cartData.is_anonymous,
      mobile: cartData.donor_phone === 1111111111 ? this.mobileControl.reset() : cartData.donor_phone,
      email: cartData.donor_email,
      address: cartData.donor_address,
      pancard: cartData.pan,
      passport: cartData.passport,
      nationality: cartData.indian,
      pincode: cartData?.pincode
    });
    if (cartData.passport) {
      this.nationalityChange();
    }
    if (cartData?.donor_extension) {
      this.extn = cartData.donor_extension;
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (this.contributeDetails && changes.contributeDetails !== undefined && changes.contributeDetails.currentValue) {
      this.getContributeFormDetails();
    }
  }

  /**Init the form */
  initForm() {
    this.amountForm = new FormGroup({
      name: this.nameControl,
      is_anonymous: this.is_anonymous = new FormControl(false),
      mobile: this.mobileControl,
      email: this.emailControl
    });

    this.emailControl.valueChanges.subscribe(val => {
      if (this.inputFieldData.email === val) return;
      this.inputFieldData.email = val;
      if (this.vars.isAutoLogin) {
        const validatorKeys = this.util.getValidatorKeys(this.emailControl);
        if (val === this.user?.email) {
          if (validatorKeys?.includes('pattern')) {
            this.updateValidation('email', true);
          }
        } else if (!validatorKeys?.includes('pattern')) {
          this.updateValidation('email', true, this.vars.email_Pattern_Regex);
        }
      }
    });
    this.mobileControl.valueChanges.subscribe(val => {
      if (this.inputFieldData.phone === val) return;
      this.inputFieldData.phone = val;
      if (this.vars.isAutoLogin) {
        const validatorKeys = this.util.getValidatorKeys(this.mobileControl);
        if (val === this.user?.phone_1) {
          if (validatorKeys?.includes('pattern')) {
            this.updateValidation('phone', true);
          }
        } else if (!validatorKeys?.includes('pattern')) {
          this.updateValidation('phone', true, this.selectedCountryData?.pattern);
        }
      }
    });
  }

  setAmount(data) {
    setTimeout(() => {
      this.baseAmount = +data;
      this.checkPanMinAmt(data);
      this.setTotalAmount();
    }, 0);
  }

  checkPanMinAmt(data) {
    if (data >= this.contributeDetails.pan_required_amount && this.contributeDetails.ask_pan && this.selectedNationality !== '0') {
      this.isPanCardExists = this.controlToggle('pancard', true, this.pancard_regex, this.user?.pan_number?.info_1);
      return true;
    } else {
      this.isPanCardExists = this.controlToggle('pancard', false);
      return false;
    }
  }

  /**Set the tip amount  */
  setTipAmount(data) {
    if (!data && this.currency === 'INR' && this.vwo.zero_tip_AB() && this.vars.pageName === 'campaign' && this.vars.fundraiser?.parent_cause_id === 20 && this.vars.validCausePM.includes(this.vars.fundraiser?.cause_id)) {
      this.vars.askTipOnPayOpt = true;
    } else {
      this.vars.askTipOnPayOpt = false;
    }
    setTimeout(() => {
      this.tipAmount = +data;
      this.setTotalAmount();
    }, 0);
  }

  setTotalAmount() {
    if (this.storageService.getFromSession('india')) {
      this.setAmountNudge(this.contributeDetails?.selected_currency === 'INR' ? 200 : this.contributeDetails.min_donation);
    }
    this.amount = (+this.baseAmount || 0) + (+this.tipAmount || 0) + (+this.independeceAmount || 0) + this.familyInsuranceAmount;
  }

  /**Set the tip amount for last tip try   */
  setLastTipAmt(data) {
    setTimeout(() => {
      this.fromToggleTip = true;
      this.tipAmount = data.tipAmt;
      this.amount = data.baseAmt + data.tipAmt;
    }, 0);
  }

  /**Set the tip percent  */
  setTipPercent(data) {
    this.tipPercent = data;
  }

  /**Set the user selected currency */
  setCurrency(data: ICurrency) {
    this.userSelectionCurrency.emit(data);
  }
  /**Is submit true */
  setIsSubmit() {
    this.router.navigate([], {
      queryParams: { payment: 'options', op: this.isMobile && this.currency !== 'INR' ? 'c' : null },
      queryParamsHandling: 'merge'
    });
  }

  // Nationality change event
  nationalityChange() {
    if (this.selectedNationality === '0' && this.contributeDetails.ask_passport) {
      this.askPassport = this.controlToggle('passport', this.contributeDetails.ask_passport, /(^[a-zA-Z0-9]{2,20}$)/);
      this.isPanCardExists = this.controlToggle('pancard', false);
    } else if (this.selectedNationality === true && this.contributeDetails.ask_pan && this.checkPanMinAmt(this.baseAmount)) {
      this.isPanCardExists = this.controlToggle('pancard', this.contributeDetails.ask_pan, /[a-zA-Z]{5}[0-9]{4}[a-zA-Z]{1}/g);
      this.askPassport = this.controlToggle('passport', false);
    } else {
      this.askPassport = this.controlToggle('passport', false);
      this.isPanCardExists = this.controlToggle('pancard', false);
    }
  }

  isAnonymousChange = (e) => {
    this.is_anonymous.setValue(e);
  }

  submitBulk = (event) => {
    this.bulkShown = true;
    this.bulkdata = null;
    this.bulkamount = null;
    try {
      if (Object.keys(event).length > 0) {
        this.bulkdata = {
          [this.campaignId]: { amount: this.amount }, ...event
        };
        this.bulkamount = Object.values(this.bulkdata).reduce((a, { amount }) => a + amount, 0);
      }
    } catch (error) { }
    this.submitPayment();
  }

  captchaResponse(e) {
    this.paymentV2.captchaResponse = e;
    this.submitPayment();
  }

  submitPayment() {
    if (!this.paymentV2.captchaResponse && !this.enableCaptha && this.params?.payment?.match('form|rd') && this.currency !== 'INR') {
      this.toggleCaptcha(true);
      return;
    }
    this.submitForm();
  }

  /**Form submit listener */
  submitForm() {
    if (this.vars.selectedFamilyInsurance) {
      this.bulkdata = {
        [this.campaignId]: { amount: this.amount - this.vars.selectedFamilyInsurance?.[this.contributeDetails?.insurance?.id]?.amount }, ...this.vars.selectedFamilyInsurance
      };
      this.bulkamount = Object.values(this.bulkdata).reduce((a, { amount }) => a + amount, 0);
    }
    const params = this.util.getUrlParams();
    const userdata = this.storageService.get('userdata');
    if (params?.utm_source?.match('internal_impact_calling|internal_stories_otd_calling')) {
      const emailUserData = userdata?.email;
      if (this.emailControl.value !== emailUserData) {
        this.util.openSnackBar('User login error, please reopen in fresh incognito window', 'error');
        this.eventsService.sendSystemEvent({
          eventName: 'user_missmatch',
          page_name: this.vars.pageName,
          info_1: emailUserData,
          info_2: this.emailControl.value,
        }).subscribe(_ => _);
        return;
      }
    }

    if (this.amountForm.valid && this.checkBaseAmtValidity()) {
      const payload = {
        'campaign_id': this.campaignId,
        'currency': this.currency,
        'donated_amount': this.amount,
        'donor_name': this.nameControl.value,
        'donor_email': this.emailControl.value,
        'is_anonymous': this.is_anonymous.value ? '1' : '0',
        'device': this.vars.deviceType,
        'donor_country': this.clientData.country_name,
        'donor_city': this.clientData?.city_name,
        'donor_extension': this.extn || userdata?.extension || '',
        'donor_phone': this.mobileControl.value.replace(/\s/g, ''),
        showError: 'false'
      };
      if (this.pincode) {
        payload['donor_pincode'] = this.amountForm.value.pincode;
      }
      if (this.enableCaptha) {
        payload['g-recaptcha-response'] = this.captcha.value;
      }
      if (typeof this.tipAmount === 'number') {
        payload['tip_amount'] = this.tipAmount;
      }
      if ((this.isQR || this.upiMode || this.origin === 'tann' || this.params?.min_donation || (this.origin === 's' && !this.params?.mini_story) || (this.payment_config?.enable_min_cart_lead && this.payment_config?.bypass_for_min_cart_only)) && !this.isSipStory) {
        payload['skipmin'] = true;
      }
      if (this.address) {
        payload['donor_address'] = this.amountForm.controls['address'].value;
      }
      if (this.isPanCardExists) {
        payload['pan'] = this.amountForm.value.pancard || '';
      }
      if (this.askPassport) {
        payload['passport'] = this.amountForm.value.passport || '';
      }
      if (this.reward) {
        payload['reward_id'] = this.reward.id;
      }
      if (this.contributeDetails.ask_citizenship && this.config.nationality) {
        payload['indian'] = this.selectedNationality === true ? true : false;
      }

      if (this.vars.couponDetails) {
        payload['coupon_code'] = this.vars.couponDetails.coupon_code;
      }

      if (this.isSipCause) {
        payload['split'] = false;
        payload['recurring'] = 1;
        if (this.ngo_sip) {
          payload['ngo_sip'] = 1;
        } else {
          payload['sip_cause'] = this.sipCause.info_3;
        }
      }
      if (this.isSipStory) {
        // payload['transaction_type'] = 'wallet_new_sip_6';
        payload['split'] = false;
        payload['recurring'] = 1;
        payload['cause_amount'] = 1;
        payload['sip_cause'] = [{ sip_cause: this.vars.default_sip_cause, amount: +this.amount }];
      }

      if (this.payment_config?.is_sip) {
        payload['recurring'] = 1;
      }

      if (this.bulkdata) {
        payload['bulkdonation'] = this.bulkdata;
        payload['donated_amount'] = this.bulkamount;
      }

      if (!payload['tip_amount'] && this.vwo.support_fee_AB() && !this.payment_config?.is_sip) {
        this.vars.supportFee = ((this.amount / 100 ) * (this.contributeDetails?.support_fee_perc ?? 1));
        payload['tip_amount'] = this.vars.supportFee;
        payload['donated_amount'] = payload['donated_amount'] + this.vars.supportFee;
      } else {
        this.vars.supportFee = 0;
      }

      if (this.vars.selectedKCart) {
        payload['campaign_products'] = this.vars.selectedKCart;
        this.util.storage.check('selectedKCart', this.vars.selectedKCart);
      } else {
        this.util.storage.delete('selectedKCart');
      }

      if (this.amount < 1) {
        /**
         * To prevent from entering values less than 1 Rs. (Example in UPI)
         * Also when we set skipmin true we still want user to pay min 1 Rs
         */
        return false;
      }
      this.sendAmountDetails(payload);
    } else {
      if(this.isMobile){
        this.util.scrollInto('amountForm');
      }  
      // opened mini story form if form is invalid
      this.inputFields = false;
      this.util.checkValidForm(this.amountForm);
      if (this.enableCaptha && this.captcha && this.captcha.invalid) {
        this.toggleCaptcha(true);
      }
    }
  }

  checkBaseAmtValidity() {
    let minDonation = this.contributeDetails.min_donation;
    if (this.vars.selectedKCart) {
      minDonation = this.vars.selectedKCart[0].per_unit_amount;
    }
    const amountCheck = new FormControl(this.baseAmount, [
      Validators.required, Validators.pattern(/^[0-9]+$/), Validators.min(minDonation), Validators.max(this.max_donation)
    ]);
    if (this.payment_config?.enable_min_cart_lead && !this.payment_config?.cart_response && this.baseAmount < minDonation) {
      this.paymentUtilService.paymentConfig.next({ bypass_for_min_cart_only: true });
      return true;
    }
    return amountCheck.valid;
  }

  /**Send the order details */
  sendAmountDetails(payload) {
    this.isLoading = true;
    this.paymentService.sendAmount(payload, this.campaignId).subscribe((res: any) => {
      if (this.paymentV2.captchaResponse && this.currency !== 'INR') {
        this.paymentV2.captchaResponse = '';
      }
      if (this.vars.isDummyEmail) {
        this.eventsService.updateCTprofile({name: payload?.donor_name, email: payload?.donor_email});
      }
      this.failedTransaction = false;
      // this.isLoading = false;
      let extraCartData = {
        timestamp: new Date().getTime()
      };
      if(this.vars.supportFee){
        extraCartData['supportFee'] = this.vars.supportFee;
      }
      if (this.vars.selected_insurance) {
        extraCartData['vendor'] = this.vars.selected_insurance.vendor;
        extraCartData['plan'] = this.vars.selected_insurance.plan;
      }
      if (this.vars.showKCart) {
        extraCartData['showKCart'] = true;
      }
      if (this.vars.showKCart && this.vars.selectedKCart) {
        extraCartData['campaign_products'] = this.vars.selectedKCart;
      }
      if (this.vars.isAutoLogin) {
        res.data.cart.donor_phone = payload.donor_phone;
      }
      this.cartResponse = { ...res.data.cart, ...extraCartData };
      this.vars.userPhoneExt = `${this.cartResponse.donor_extension}`;
      this.vars.userPhoneNumber = `${payload?.donor_phone || this.cartResponse.donor_phone}`;
      if (this.user && !this.user?.phone_1) {
        this.user.extension = this.vars.userPhoneExt;
        this.user.phone_1 = this.vars.userPhoneNumber;
        this.util.setUserData(this.user);
      }

      if (this.contributeDetails.ask_citizenship && this.config.nationality) {
        this.cartResponse.indian = this.selectedNationality === true ? true : '0';
      }
      this.paymentUtilService.initaiteQr = true;
      if (this.fromToggleTip) {
        this.pushToggleEvents(payload);
      }
      if (this.isSipCause && !this.ngo_sip) { this.cartResponse['sip_cause'] = this.sipCause.info_3; }
      if (this.isSipCause && this.ngo_sip) { this.cartResponse['ngo_sip'] = 1; }
      this.paymentUtilService.cartResponse.next(this.cartResponse);
      this.paymentV2.paymentConfig.next({ cart: this.cartResponse });
      this.storageService.checkFromSession('cartData', this.cartResponse);
      this.storageService.checkFromSession('cartDataForOTDSIP', this.cartResponse);
      this.paymentUtilService.paymentConfig.next({ cart_response: this.cartResponse });
      if (this.isSipStory || this.payment_config?.is_sip) {
        const cart_data = {
          ...res.data,
          sip_cause_str: this.util.jsonToString(payload?.sip_cause),
          timestamp: new Date().getTime()
        }
        this.storageService.checkFromSession('sip_cart', cart_data);
        this.paymentV2.eventForInitiatePayment(11, res.data.campaign, res.data.cart, {});
        this.paymentV2.eventAfterCreatingCart(res.data.campaign, res.data.cart, {});
      } else {
        this.storageService.checkFromSession('cartData', this.cartResponse);
      }
      if (res.data.hasOwnProperty('token')) {
        this.vars.loginMethod = 'cart';
        this.authService.userLogin(res.data).then(() => {
          this.afterCartCreateActions();
        });
      } else {
        this.afterCartCreateActions();
      }
      this.addCoupon();
    }, (err) => {
      this.paymentUtilService.paymentConfig.next({ bypass_for_min_cart_only: false });
      this.util.openSnackBar(err?.error?.message, 'error');
      this.isLoading = false;
      if (this.enableCaptha && this.captcha && err?.status !== 403) {
        this.toggleCaptcha(true);
      }
    });
  }

  afterCartCreateActions() {
    if (this.isSipCause || this.isSipStory || (this.ngo_sip && this.isSipCause) || this.payment_config?.is_sip) {
      this.sipRedirection();
      return;
    }
    this.pushEvents();
    if (!this.payment_config.bypass_for_min_cart_only) {
      this.getPaymentOptions(this.contributeDetails.selected_currency);
    } else {
      this.isLoading = false;
    }
    if (this.bulkShown) {
      this.bulkDataEvent();
    }
    if (this.vars.selectedFamilyInsurance) {
      this.familyInsureEvent();
    }
    this.paymentUtilService.paymentConfig.next({ bypass_for_min_cart_only: false });
  }

  familyInsureEvent() {
    this.eventsService.sendSystemEvent({
      eventName: 'Insurance_clicked',
      info_1: this.vars.selectedFamilyInsurance?.[this.contributeDetails?.insurance?.id]?.amount,
      info_2: 'insurance for family'
    }).subscribe(_ => _);
  }

  bulkDataEvent() {
    if (this.bulkdata) {
      this.eventsService.sendSystemEvent({
        eventName: 'multi_donation',
        info_1: `${JSON.stringify(this.bulkdata)}` || '',
        info_2: this.bulkamount || ''
      }).subscribe(_ => _);
    } else {
      this.eventsService.sendSystemEvent({
        eventName: 'skip multi_donation',
      }).subscribe(_ => _);
    }
  }

  sipRedirection() {
    const qparam = {
      currency: this.currency,
      amt: this.amount || '',
      campaign_id: this.campaignId
    };
    if (this.isSipCause && !this.ngo_sip) {
      qparam['sip_cause'] = this.sipCause.info_3;
    }
    if (this.isSipStory) {
      qparam['sip_story'] = 1;
    }
    if (this.ngo_sip) {
      qparam['ngo_sip'] = 1;
    }
    this.dialog.closeAll();
    this.util.router.navigate(
      ['/new/sip/payment-standalone'], {
      queryParams: qparam, queryParamsHandling: 'merge'
    }
    );
  }


  addCoupon() {
    if (this.config.utm_nudge && this.paymentUtilService.utmProceedClicked) {
      this.apiService.applyCoupon(this.campaignId, { coupon_id: 59 }).subscribe(res => {
        if (!res.error) {
          // this.paymentUtilService.utmProceedClicked = true;
          // this.dialog.closeAll();
          this.storageService.add('walletOffer100', true);
          // this.util.openSnackBar(res.data, 'success');
        }
      }, err => {
        this.storageService.add('walletOffer100', true);
        if (err.error) {
          this.dialog.closeAll();
        }
      });
    }
  }

  /**Get the form details */
  getContributeFormDetails() {
    this.familyInsuranceAmount = 0;
    if (this.contributeDetails.pincode && this.config.pincode) {
      let pattern;
      if (this.contributeDetails.selected_currency === 'INR') {
        pattern = '^[1-9][0-9]{5}$';
      }
      this.askPincode = this.controlToggle('pincode', this.contributeDetails.pincode, pattern);
    }
    if (this.config.anonymous_from_api) {
      this.is_anonymous.setValue(this.contributeDetails.anonymous);
    }
    this.nationalityChange();
    if (this.contributeDetails.address && this.config.address) {
      this.address = this.controlToggle('address', this.contributeDetails.address);
    }
    if (this.contributeDetails.ask_citizenship && this.config.nationality) {
      this.amountForm.addControl('nationality', this.nationality = new FormControl(true, [Validators.required]));
    }
    if (this.isQR && this.isQR.name.match('UPI|Paytm')) {
      this.contributeDetails.min_donation = this.origin === 's' ? 99 : this.contributeDetails.min_donation;
    }
    if (this.params?.min_donation) {
      this.contributeDetails.min_donation = +this.params?.min_donation;
    }
    if (this.isSipStory) {
      this.contributeDetails.min_donation = +this.paymentUtilService.getMinimumAmountOnlySIP(this.contributeDetails.selected_currency);
    }
  }
  /**check if control present Add and remove them */
  controlToggle(name, status, pattern?, value?) {
    const validatorsArray = [Validators.required];
    if (pattern) {
      validatorsArray.push(Validators.pattern(pattern));
    }
    if (status && !this.amountForm.controls[name]) {
      this.amountForm.addControl(name, this[name] = new FormControl(value || '', validatorsArray));
      return true;
    } else if (!status) {
      this.amountForm.removeControl(name);
      return false;
    } else {
      return true;
    }
  }
  /**Get the payment available options from the gateway */
  getPaymentOptions(currency, doNotSetOption = false) {
    let params = `&mobile_no=${this.user?.phone_1}&is_mobile=${this.util.isMobile() ? 1 : 0}&campaign_id=${this.cartResponse?.campaign_id}&indian=${this.cartResponse?.indian === true ? true : false}`;
    if (this.bulkdata || doNotSetOption) {
      params = params.concat(`&amount=${this.cartResponse?.donated_amount}`);
    } else {
      params = params.concat(`&amount=${this.amount}`);
    }
    if (this.upiMode) {
      params = params.concat(`&mode=UPI`);
    }
    if (this.params['utm_source'] === 'internal_stories_otd_calling') {
      params = params.concat(`&internal_mini_story=1`);
    }
    this.paymentService.setConfig({optionsResponse: undefined});
    this.paymentService.getPaymentOptions(currency, params).subscribe({
      next: (res: any) => {
        res.data['doNotSetOption'] = doNotSetOption;
        this.paymentUtilService.paymentOptionsObs.next(res.data);
        this.paymentV2.paymentOptions.next(res.data);
        this.paymentService.setConfig({optionsResponse: res.data});
        // if (!this.vwo.paymentV2AB()) {
          if (this.upiMode && this.util.getMobileOperatingSystem() !== 'iOS') {
            this.submitOrder.next({ mode: this.upiMode.mode, mode_value: this.upiMode.value, payment_gateway: this.upiMode?.payment_gateway || '' });
          }
          if (Object.keys(res.data.options).length === 1) {
            for (const [key] of Object.entries(res.data.options)) {
              const paymentOption = key.charAt(0).toLowerCase();
              this.router.navigate([], {
                queryParams: { payment: 'options', op: paymentOption },
                queryParamsHandling: 'merge'
              });
              if (paymentOption === 'u') {
                this.vars.upiTimerOuter.next(true);
              }
              break;
            }
          } else {
            if (this.vars.isPhonePe) {
              this.paymentUtilService.miniApps.next({ mode: 'CASH', mode_value: 'PHONEPE' });
              this.isLoading = true;
              setTimeout(() => { this.isLoading = false; }, 10000);
            } else if (this.vars.isPaytmMini) {
              this.paymentUtilService.miniApps.next({ mode: 'PAYTMMA', mode_value: 'PAYTM' });
              this.isLoading = true;
              setTimeout(() => { this.isLoading = false; }, 10000);
            } else if (!doNotSetOption) {
              this.setIsSubmit();
            }
          }
        // }
        if (this.paymentFlowType === 'onpage' && !this.failedTransaction) {
          this.paymentUtilService.isSubmitted.next(true);
        }
        this.isLoading = false;
      },
      error: (err) => {
        this.isLoading = false;
        this.vars.isOrderLoading = false;
      }
    });
  }
  /**ALL THE EVENT FOR CREATING THE CART FOR THE PAYMENT */
  pushEvents() {
    const data = {
      isLoggedIn: this.isLoading,
      extn: this.extn,
      campaignId: this.campaignId,
      reward: this.reward,
      currency: this.currency,
      amount: this.amount,
      position: this.position,
      info3: this.tipPercent
    };
    if (this.contributeDetails && this.contributeDetails.slabs) {
      data['slabs'] = this.contributeDetails.slabs;
    }
    this.paymentUtilService.donationFormEvents(this.cartResponse, data, this.onpage);
  }

  /** Adding another event if the user has donated using toggle */
  pushToggleEvents(data) {
    const payload = {
      eventName: 'tip_amount',
      event_type: 'campaign',
      page_name: 'campaign',
      info_1: `${data.tip_amount}/${data.donated_amount}`,
      info_2: data.tip_amount ? 'toggle' : '',
      info_3: 'campaign',
      info_4: ''
    };
    this.eventsService.sendSystemEvent(payload).subscribe(_ => _);
  }

  memorialSipCheck() {
    this.memorialTooltip = !this.isSipCause;
    if (this.isSipCause) {
      this.tipAmount = 0;
      this.amount = this.baseAmount;
    }
    const systemEvent = {
      eventName: this.isSipCause ? 'check monthly giving' : 'Uncheck monthly giving',
      page_name: this.vars.pageName
    };
    this.eventsService.sendSystemEvent(systemEvent).subscribe(_ => _);
  }

  independeceAmount = 0;

  setAmountNudge = (e) => {
    if (e > 0) {
      this.independeceAmount = e;
    } else {
      this.independeceAmount = 0;
    }
    this.amount = this.amount + e;
  }

  updateFamilyInsurance = (data) => {
    if (this.vars.selectedFamilyInsurance) {
      this.familyInsuranceAmount = +(Object.values(this.vars.selectedFamilyInsurance).reduce((a, { amount }) => a + amount, 0)) || 0;
    } else {
      this.familyInsuranceAmount = 0;
      this.bulkdata = undefined;
      this.bulkamount = undefined;
    }
    setTimeout(() => {
      this.setTotalAmount();
    }, 100);
  }

  addSip = (e?) => {
    this.vars.selectedOtdSipAmt = e;
  }

  showInputFields(e = true) {
    this.inputFields = !e;
    if (e) {
      // this.emailControl.setValue('');
      // this.updateValidation('email', true, this.vars.email_Pattern_Regex);
      // this.updateValidation('phone', true);
    }
  }

  onFocusOut(field: 'email'|'phone') {
    if (field === 'email' && this.vars.isAutoLogin) {
      if (this.emailControl.value === this.user.email) {
        this.updateValidation('email', true);
      } else {
        this.updateValidation('email', true, this.vars.email_Pattern_Regex);
      }
    } else if (field === 'phone' && this.vars.isAutoLogin) {
      if (this.mobileControl.value === this.user?.phone_1) {
        this.updateValidation('phone', true);
      } else {
        this.updateValidation('phone', true, this.selectedCountryData?.pattern);
      }
    }
  }

  updateValidation(field: 'email'|'phone', require: boolean, pattern?: any ) {
    const validators = [];
    if (require) validators.push(Validators.required);
    if (pattern) validators.push(Validators.pattern(pattern));
    if (field === 'email') {
      this.emailControl.clearValidators();
      this.emailControl.addValidators(validators);
      this.emailControl.updateValueAndValidity();
    } else if (field === 'phone') {
      this.mobileControl.clearValidators();
      this.mobileControl.addValidators(validators);
      this.mobileControl.updateValueAndValidity();
    }
  }

  setCountry(e) {
    this.selectedCountryData = e;
    this.extn = e?.dialCode;
    if (this.vars.isAutoLogin && e?.pattern?.test(this.mobileControl.value.replaceAll('*', '1'))) {
      this.updateValidation('phone', true);
    } else {
      this.updateValidation('phone', true, e?.pattern);
    }
  }

  ngOnDestroy() {
    this.subs.forEach(s => s.unsubscribe());
  }
}
